import { DrawerComponent } from '~/shared/ui/Drawer'
import { Content } from './Content'

type MoreDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function MoreDrawer({ isShow, onClose }: MoreDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content />
    </DrawerComponent>
  )
}
